import { useEffect, useState,useCallback } from 'react';
import Pagination from '@src/common/Pagination';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import * as HELPER from "@src/config/helper";
import {DEFAULT_PAGE_NO, DEFAULT_PAGINATION_COUNT, INS_TYPE_CTPL,LEAD_LIST_HEADER_COLUMN, REGEX_CAMEL_CASE} from '@src/config/constant';
import { useSelector,useDispatch } from 'react-redux';
import { toast } from "react-toastify";
import ClaimTypePopup from '@src/pages/claims/list/ClaimTypePopup';
import ClaimSuccessPopup from '@src/pages/claims/list/ClaimSuccessPopup';
import { getMasterConfig } from '@src/store/slices/insurance';
import PaymentInfo from './PaymentInfo';

function InsuranceListTable(props: any) {
    let { insuranceList, paginationData, selectedFilters} = props;
    
    const navigate = useNavigate();
    const page = DEFAULT_PAGE_NO;
    const [insuranceListData, setInsuranceListData] = useState<any>([]);
    const commonState = useSelector((state: any) => state.common)
    const [masterConfig, setMasterConfig] = useState<any>({});

    const [showModal, setShowModal] = useState<boolean>(false);
    const [showSuccessModal, setShowSuccessModal] = useState<boolean>(false);
    const [leadId, setLeadId] = useState<number | null>(null);
    const [leadHashId,setLeadHashId] = useState(null);
    const [successPopUpText, setSuccessPopupText] = useState('');
    const [paymentDone, setPaymentDone] = useState(false);
    const [showPaymentInfoPopup, setShowPaymentInfoPopup] = useState(false);
    const [paymentInfo, setPaymentInfo] = useState<any>({});
    const [screenType, setScreenType] = useState('');

    const setPopupText = (text:string) => {
        setSuccessPopupText(text);
    }

    const setIsPaymentDone = (paymentDone:boolean) => {
        setPaymentDone(paymentDone)
    }

    const handleShow = (id: number,leadData:any) => {
        setLeadId(id);
        setPaymentInfo(leadData);
        setShowModal(true)
    };

    // const setHashId = (id:any) => {
    //     setLeadHashId(id);
    // }

    const handleClose = () => setShowModal(false);

    const handleSuccessPopupClose = () => {
        setShowSuccessModal(false)
        setInsuranceListData((prevList:any) =>
            prevList.map((item:any) =>
                item.hashId === leadHashId
                    ? { ...item, claim_progress: 1, is_payment_done: paymentDone }
                    : item
            )
        );
    };

    const dispatch: any = useDispatch();

    useEffect(() => {
        setInsuranceListData(insuranceList);
    }, [insuranceList]);

    const fetchMasterConfig:any = useCallback(async () => {
        try {
        const res: any = await dispatch(getMasterConfig());
        if (res) {
            setMasterConfig(res);
        }
        } catch (error) {
        console.error("Failed to fetch master config:", error);
        }
    }, [dispatch]);

    useEffect(() => {
        if (!commonState?.common || Object.keys(commonState.common).length === 0) {
        fetchMasterConfig();
        } else {
        setMasterConfig(commonState.common);
        }
    }, [commonState?.common, fetchMasterConfig]);
    

   

    // const detailPageRedirect = (leadId: string) => {
    //     navigate(`/details/personal-details/${leadId}`);
    // }

    const handleRequestData = (params: any) => {
        let apiParams = {
            ...selectedFilters,
            page_number: params.page_no
        }

        props.getInsuranceListing(apiParams)

    }
   
    const downloadPolicy = (urls:any,name:string, policy_number:any) => {
        if(urls.length){
            let formattedCustomerName = name.toLowerCase()
            .replace(REGEX_CAMEL_CASE, (word:any, index:number) =>
                index === 0 ? word.toLowerCase() : word.toUpperCase()
            )
            .replace(/\s+/g, "");
            let result = `${formattedCustomerName}_${policy_number}.zip`;
            HELPER.downloadPolicy(urls,result);    
        }else{
            toast.error("No File Found");
        }
    }

    const makePayment = (leadId:any) => {
        navigate(`/payment-add/${leadId}`);
    }

    const goToQuoteDetail = (leadId:any) => {
        navigate(`/quote-details/${leadId}`);
    }

    const showPaymentInfo = (leadData:any,screenType = "pending_payment") => {
        setPaymentInfo(leadData);
        setScreenType(screenType);
        setShowPaymentInfoPopup(true);
    }
    let ColumnName= [
        'Customer Name', 'Vehicle Name','Policy No', 'Policy Expiry Date', 'Claim Status', 'Created On', 'Issue Date', 'Pending Payment', 'Due Date', 'Status'
    ]
    

    return (
        <div className={(selectedFilters?.type && selectedFilters?.type==="claim")?`lead-list-data-table data-table managepanel-tab claim-list-type wap-table`:`lead-list-data-table data-table managepanel-tab wap-table`} >
            <table >
                <thead>
                    <tr>
                       {
                        LEAD_LIST_HEADER_COLUMN[selectedFilters?.status_type || selectedFilters?.type].map((data: any, index: number) =>
                        <th key={index}>{data}</th>
                        )
                       }
                    </tr>
                </thead>
                <tbody>
                {
                    insuranceListData.length?
                    insuranceListData.map((lead: any, key: number) =>
                        <tr key={key}>
                            <td>
                                <div className="table-txt-data cursor-point customer-name-table">
                                    <h5 title={`${lead.name}`} onClick={selectedFilters?.type !== "claim" ? () => goToQuoteDetail(lead.hashId) : undefined}>{lead.name || ""}</h5>
                                </div>
                            </td>
                            <td data-label={ColumnName[1]}>
                                <div className="table-txt-data">
                                    <h5 title={`${lead.make_name || ""} ${lead.model_name || ""} ${lead.version_name || ""}`}>{`${lead.make_name || ""} ${lead.model_name || ""} ${lead.version_name || ""}`}</h5>
                                    
                                    {/* <span title ="Plate Number" className='plate_no_text'>{lead.plate_no || ""}</span> */}
                                    {
                                     (lead.insurance_type===INS_TYPE_CTPL && lead.mv_number) && <span title ="MV File number ">{lead.mv_number || ""}</span>  
                                    }
                                </div>
                            </td>
                            {
                                // selectedFilters.status_type === "policy_issued" &&
                                <td data-label="Plate Number">
                                    <div className="table-txt-data"> 
                                        <span title ={lead.plate_no}>{lead.plate_no || ""}</span> 
                                    </div>
                                </td> 
                            }
                            
                            {/* <td>
                               <div className="table-txt-data">
                                <span title ="Plate Number">{lead.plate_no || ""}</span>
                                    {
                                        (lead.insurance_type===INS_TYPE_CTPL && lead.mv_number) && <span title ="MV File number ">{lead.mv_number || ""}</span>  
                                    }
                                </div>
                            </td> */}
                            {
                              (selectedFilters?.status_type && ["submitted","pending"].includes(selectedFilters?.status_type)) &&
                                <td data-label={ColumnName[5]}>
                                    <div className="table-txt-data"> 
                                        <span>{moment(lead.applied_on).format('DD MMM yyyy')}</span>
                                    </div>
                                </td>  
                            }
                            {
                              (selectedFilters?.status_type && ["policy_issued"].includes(selectedFilters?.status_type)) &&
                                <>
                                    <td  data-label={ColumnName[6]}>
                                        <div className="table-txt-data"> 
                                            <span>{moment(lead.policy_issue_date).format('DD MMM yyyy')}</span>
                                        </div>
                                    </td>  
                                    <td className='raised-claimed-btn-list'>
                                        <div className="raise-payment-btn">
                                            {
                                              (!lead.is_payment_done) &&   <button className="btn-line btn-width-auto m-sm-r"  onClick={()=>makePayment(lead.hashId)}>
                                              <i className="ic-wallet m-xs-r"></i>Make Payment</button>
                                            } 
                                            {
                                               (lead.is_policy_documents===1 && lead.policy_documents.length>0) && <button className="btn-line btn-width-auto " onClick={()=>downloadPolicy(lead.policy_documents,lead.name,lead.policy_number)}>
                                                  <i className="ic-save_alt m-xs-r"></i>Download Policy</button>
                                            }
                                           
                                        </div> 
                                    </td>
                                </>  
                            }
                            {
                              (selectedFilters?.status_type && ["pending_payment"].includes(selectedFilters?.status_type)) &&
                                <>
                                    <td data-label={ColumnName[7]}>
                                        <div className="table-txt-data amount-wrapper"> 
                                            <span title={`${HELPER.addCurrencyFormatting(lead.pending_amount)}`}>{HELPER.addCurrencyFormatting(lead.pending_amount) || 0}</span>
                                            <span data-tooltip-id="my-tooltip-4" title="" className="tooltio-ic" onClick={() => showPaymentInfo(lead)}><i className="ic-info-icon1"></i></span>
                                        </div>
                                    </td>  
                                    <td data-label={ColumnName[8]}>
                                        <div className="table-txt-data"> 
                                            <span className={(lead.due_date_color_status)?`red`:``}>{(lead.due_date_color_status)?`${lead.due_date_days} Days left`:moment(lead.due_date).format('DD MMM yyyy')}</span>
                                        </div>
                                    </td>
                                    <td data-label={ColumnName[9]}>
                                        <div className="table-txt-data"> 
                                            <span className={(lead.raised_soa===1)?`active-raised`:``}>{(lead.raised_soa===1)?`Raised SOA`:"-"}</span>
                                        </div>
                                    </td>
                                </>  
                            }
                            {
                              (selectedFilters?.type && ["claim"].includes(selectedFilters?.type)) &&
                                <>
                                    <td data-label={ColumnName[2]}>
                                        <div className="table-txt-data">
                                            <span title ={lead.policy_number}>{lead.policy_number || ""}</span>
                                        </div>
                                    </td>
                                    <td data-label={ColumnName[3]}>
                                        <div className="table-txt-data"> 
                                            <span>{moment(lead.policy_expire_date).format('DD MMM yyyy')}</span>
                                        </div>
                                    </td> 
                                    <td  data-label={ColumnName[4]}>
                                        <div className="table-txt-data amount-wrapper"> 
                                        {lead?.raise_claim?.some((claim:any) => claim.is_raised === true) ? (
                                            <>
                                                <span className="red">Raised</span>
                                                <span data-tooltip-id="my-tooltip-4" title="" className="tooltio-ic" onClick={() => showPaymentInfo(lead,'claim')}>
                                                    <i className="ic-info-icon1"></i>
                                                </span>
                                            </>
                                        ) : (
                                            <span>-</span>
                                        )}
                                        </div>
                                    </td>
                                    <td className='raised-claimed-btn-list'>
                                        <div className="raise-payment-btn">
                                        {
                                            lead.raise_claim?.some((claim:any) => claim.is_raised === false) && (
                                                <button
                                                className="btn-line btn-width-auto m-sm-r"
                                                onClick={() => handleShow(lead.leadId,lead)}
                                                >
                                                <i className="ic-rais_claim m-xs-r"></i>Raise Claim
                                                </button>
                                            )
                                        }  
                                        {
                                            (!lead.is_payment_done) &&<button className="btn-line btn-width-auto"  onClick={()=>makePayment(lead.hashId)}>
                                            <i className="ic-wallet m-xs-r"></i>Make Payment</button>
                                        } 
                                        </div> 
                                    </td>
                                </>  
                            }
                            
                        </tr>
                    )
                    :
                    <tr><td colSpan={LEAD_LIST_HEADER_COLUMN[selectedFilters?.status_type || selectedFilters?.type].length} style={{ textAlign: 'center' }}>No data found</td></tr>
                }
                </tbody>
            </table>
            <ClaimTypePopup show={showModal} handleClose={handleClose} claimTypes={masterConfig?.claim_type || []} leadId={leadId} leadDetail={paymentInfo}
                onSuccess={(response: any) => {
                    setLeadHashId(response.leadHashId);
                    setPopupText(response.popUpText);
                    setIsPaymentDone(response.payment_done);
                    setShowModal(false);
                    setShowSuccessModal(true);
                }}
            />
            <PaymentInfo show={showPaymentInfoPopup} handleClose={() => { setShowPaymentInfoPopup(false)}} leadDetail={paymentInfo} screenType={screenType}></PaymentInfo>
            <ClaimSuccessPopup show={showSuccessModal} handleClose={handleSuccessPopupClose} leadId={leadHashId} popupText={successPopUpText} payment_done={paymentDone}></ClaimSuccessPopup>
            {(paginationData && paginationData['total'] > DEFAULT_PAGINATION_COUNT) && <Pagination paginateData={{
                page,
                loading: false,
                totalLengthWithoutPagination: paginationData['total'],
                paginationData,
                filteredData: selectedFilters
            }}
                sendRequestDataToParent={handleRequestData} />}
        </div >
    )
}

export default InsuranceListTable